import {citationParts} from './citation-parts'
import type {ReplyBlock} from '../pages/project-interactions'

/** Older server responses prefixed source metadata to prose. Render that
 * metadata from the bound citation records instead, without rewriting facts. */
export function knowledgeAnswerBody(text:string):string {
 return text.replace(/^依据[：:](?:《[^\n]+?》当前基线 r\d+(?:（共 \d+ 页）)?[；。\s]*)+\n\s*\n/u,'')
}

export function answerCitationNumbers(text:string,count:number):number[] {
 return [...new Set(text.split(/(`[^`]+`)/g).filter(part=>!part.startsWith('`')).flatMap(part=>citationParts(part,count).flatMap(ref=>ref.number?[ref.number]:[])))]
}

export function mergeAnswerLists(blocks:ReplyBlock[]):ReplyBlock[] {
 return blocks.reduce<ReplyBlock[]>((output,block)=>{
  const previous=output.at(-1)
  if(block.kind==='list'&&previous?.kind==='list')previous.lines.push(...block.lines)
  else output.push({...block,lines:[...block.lines]})
  return output
 },[])
}

/** Group adjacent repeated labels; keep every original fact and citation. */
export function groupedAnswerItems(lines:string[]):{label?:string;lines:string[]}[] {
 const result:{label?:string;lines:string[]}[]=[]
 for(let index=0;index<lines.length;index++){
  const labelled=(line:string)=>{const match=line.match(/^\*\*([^*\n]+)\*\*\s*([：:]?)\s*(.+)$/u);return match&&(/[：:]$/.test(match[1]!)||match[2])?{label:match[1]!.replace(/[：:]$/,'').trim(),body:match[3]!}:null}
  const first=labelled(lines[index]!),next=lines[index+1]&&labelled(lines[index+1]!)
  if(first&&next&&first.label===next.label){
   const group={label:first.label,lines:[first.body]}
   while(index+1<lines.length){const item=labelled(lines[index+1]!);if(!item||item.label!==first.label)break;group.lines.push(item.body);index++}
   result.push(group)
  }else result.push({lines:[lines[index]!]})
 }
 return result
}
